import { Fragment } from 'react'
import BlockFullImage1Col from 'src/components/Common/BlockFullImage1Col'
import { isActive } from 'src/utils/contentByDate'
import Christmas from './Christmas'
import FlashSale from './FlashSale'
import NewYear from './NewYear'
import HomeBlackFriday from './HomeBlackFriday'
import HomeJCK from './HomeJCK'
import Halloween from './Halloween'
import SemiAnnualSale from './SemiAnnualSale'

const ChristmasStartDate = '12/23/2024 00:00:00'
const ChristmasEndDate = '12/25/2024 23:59:59'
const FlashSaleStartDate = '12/26/2024 00:00:00'
const FlashSaleEndDate = '12/31/2024 23:59:59'
const NewYearStartDate = '12/29/2023 00:00:00'
const NewYearEndDate = '1/4/2024 23:59:59'
const BlackFridayStartDate = '11/29/2024 00:00:00'
const BlackFridayEndDate = '12/2/2024 23:59:59'
const JCKStartDate = '5/31/2024 00:00:00'
const JCKEndDate = '6/30/2024 23:59:59'
const SemiAnnualSaleStartDate = '9/10/2024 00:00:00'
const SemiAnnualSaleEndDate = '9/13/2024 23:59:59'
const HalloweenStartDate = '10/29/2024 00:00:00'
const HalloweenEndDate = '11/3/2024 23:59:59'

const HeroHome = () => {
  const aux = []
  isActive(ChristmasStartDate, ChristmasEndDate) && aux.push(<Christmas key='Christmas' />)
  isActive(FlashSaleStartDate, FlashSaleEndDate) && aux.push(<FlashSale key='FlashSale' />)
  isActive(NewYearStartDate, NewYearEndDate) && aux.push(<NewYear key='NewYear' />)
  isActive(BlackFridayStartDate, BlackFridayEndDate) && aux.push(<HomeBlackFriday key='BlackFriday' />)
  isActive(JCKStartDate, JCKEndDate) && aux.push(<HomeJCK key='JCK' />)
  isActive(SemiAnnualSaleStartDate, SemiAnnualSaleEndDate) && aux.push(<SemiAnnualSale key='SemiAnnualSale' />)
  isActive(HalloweenStartDate, HalloweenEndDate) && aux.push(<Halloween key='Halloween' />)
  return (
    <>
      {aux.length >= 1 ? (
        aux.map((component, index) => <Fragment key={index}>{component}</Fragment>)
      ) : (
        <BlockFullImage1Col
          title={['home.whereInnovation.title']}
          subtitle={['home.whereInnovation.subtitle']}
          image='https://meteor.stullercloud.com/das/137585415?wid=1920'
          bgColor='#181721'
          video='https://gemvision.com/Images/Banner_Animation_Test_v14.mp4'
        />
      )}
    </>
  )
}
export default HeroHome
